var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base_aggregator", {
        attrs: { provider_id: this.provider_id, provider_type: "pwa" },
        on: {
          edit_location: _vm.edit_location,
          get_json: _vm.get_json,
          show_menu: _vm.show_menu,
          add_location: _vm.add_location,
          head_action: _vm.head_action,
        },
        scopedSlots: _vm._u([
          {
            key: "base_location_list",
            fn: function (ref) {
              var draw_locations = ref.draw_locations
              var listeners = ref.listeners
              var has_online = ref.has_online
              var has_offline = ref.has_offline
              var has_sync = ref.has_sync
              var has_sync_update = ref.has_sync_update
              var has_json = ref.has_json
              var has_preview = ref.has_preview
              var has_busy_mode = ref.has_busy_mode
              return [
                _c(
                  "b-tabs",
                  { attrs: { "content-class": "mt-3" } },
                  [
                    _c(
                      "b-tab",
                      { attrs: { title: _vm.__t("Go Direct"), active: "" } },
                      [
                        draw_locations.length > 0
                          ? _c(
                              "ul",
                              {
                                staticClass: "nav-menu mb-sm-4 mb-md-0 rounded",
                              },
                              _vm._l(
                                draw_locations.filter(function (item) {
                                  return (
                                    item.provider === "pwa" &&
                                    item.is_qr_location == false
                                  )
                                }),
                                function (item) {
                                  return _c(
                                    "li",
                                    { staticClass: "location_block" },
                                    [
                                      _c(
                                        "location-item",
                                        _vm._g(
                                          {
                                            key: "location_" + item.id,
                                            attrs: {
                                              item: item,
                                              "has-online": has_online,
                                              "has-offline": has_offline,
                                              "has-sync": has_sync,
                                              "has-sync-update":
                                                has_sync_update,
                                              "has-json": has_json,
                                              "has-preview": has_preview,
                                              "has-busy-mode": has_busy_mode,
                                            },
                                          },
                                          listeners
                                        )
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("b-tab", { attrs: { title: _vm.__t("Go Direct QR") } }, [
                      _c("div", { staticClass: "button_add mb-4" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-md btn-block btn-outline-info waves-effect waves-themed",
                            on: { click: _vm.add_qr_location },
                          },
                          [
                            _c("span", { staticClass: "fal fa-eject mr-1" }),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.__t("ADD_QR_LOCATION")) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        draw_locations.length > 0
                          ? _c(
                              "ul",
                              {
                                staticClass: "nav-menu mb-sm-4 mb-md-0 rounded",
                              },
                              _vm._l(
                                draw_locations.filter(function (item) {
                                  return (
                                    item.provider === "pwa" &&
                                    item.is_qr_location == true
                                  )
                                }),
                                function (item) {
                                  return _c(
                                    "li",
                                    { staticClass: "location_block" },
                                    [
                                      _c(
                                        "location-item",
                                        _vm._g(
                                          {
                                            key: "location_" + item.id,
                                            attrs: {
                                              item: item,
                                              "has-online": has_online,
                                              "has-offline": has_offline,
                                              "has-sync": has_sync,
                                              "has-sync-update":
                                                has_sync_update,
                                              "has-json": has_json,
                                              "has-preview": has_preview,
                                              "has-busy-mode": has_busy_mode,
                                            },
                                          },
                                          listeners
                                        )
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("b-tab", { attrs: { title: _vm.__t("API") } }, [
                      draw_locations.length > 0
                        ? _c(
                            "ul",
                            { staticClass: "nav-menu mb-sm-4 mb-md-0 rounded" },
                            _vm._l(
                              draw_locations.filter(function (item) {
                                return item.provider === "api"
                              }),
                              function (item) {
                                return _c(
                                  "li",
                                  { staticClass: "location_block" },
                                  [
                                    _c(
                                      "location-item",
                                      _vm._g(
                                        {
                                          key: "api_location_" + item.id,
                                          attrs: {
                                            item: item,
                                            "has-online": has_online,
                                            "has-offline": has_offline,
                                            "has-sync": has_sync,
                                            "has-sync-update": has_sync_update,
                                            "has-json": has_json,
                                            "has-preview": has_preview,
                                            "has-busy-mode": has_busy_mode,
                                          },
                                        },
                                        listeners
                                      )
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("pwa_location_modal"),
      _vm._v(" "),
      _c("pwa_qr_location_modal"),
      _vm._v(" "),
      _c("pwa_settings_modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }